import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/providers";
import "./shared/tokens.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root missing");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
